import { render, staticRenderFns } from "./EditPageSectionItems.vue?vue&type=template&id=1c36cfca&scoped=true&"
import script from "./EditPageSectionItems.vue?vue&type=script&lang=js&"
export * from "./EditPageSectionItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c36cfca",
  null
  
)

export default component.exports